import { authHttp } from '../http'
import * as routes from '../../routes/settings.routes'
import { errorHandler } from '../../../util/error.service'

export async function getTps() {
  try {
    const response = await authHttp().get(routes.urlTps)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getTpsPaginados({ page, pageSize, search }) {
  try {
    const response = await authHttp().get(routes.urlTpsPaginados({ page, pageSize, search }))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getTpById(tp_id) {
  try {
    const response = await authHttp().get(routes.urlTpById(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveTp({
  id,
  name,
  actived,
  show_vehicles_by,
  operation_center_default_id,
  expedicao_gerar_picking_completo,
  entregas_picking_concluido_carregamento,
  bloquear_envio_rota_sem_pallet_carregado,
  mfa_habilitado,
  reentrega_exige_ocorrencia,
  address,
  district,
  number,
  city_id,
  latitude,
  longitude,
  cnpj,
  total_tpdrive_licenses,
  companies_limit,
  tp_user_admin,
  grafos_user_id,
  token_grafos,
  grafos_ativo,
}) {
  try {
    const response = id
      ? await authHttp().put(routes.urlTp, {
          id,
          name,
          actived,
          show_vehicles_by,
          operation_center_default_id,
          expedicao_gerar_picking_completo,
          entregas_picking_concluido_carregamento,
          bloquear_envio_rota_sem_pallet_carregado,
          mfa_habilitado,
          reentrega_exige_ocorrencia,
          address,
          district,
          number,
          city_id,
          latitude,
          longitude,
          cnpj,
          total_tpdrive_licenses,
          companies_limit,
          tp_user_admin,
          grafos_user_id,
          token_grafos,
          grafos_ativo,
        })
      : await authHttp().post(routes.urlTp, {
          name,
          actived,
          show_vehicles_by,
          operation_center_default_id,
          expedicao_gerar_picking_completo,
          entregas_picking_concluido_carregamento,
          bloquear_envio_rota_sem_pallet_carregado,
          mfa_habilitado,
          reentrega_exige_ocorrencia,
          address,
          district,
          number,
          city_id,
          latitude,
          longitude,
          cnpj,
          total_tpdrive_licenses,
          companies_limit,
          tp_user_admin,
          grafos_user_id,
          token_grafos,
          grafos_ativo,
        })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveAssocTpEmpresa(item) {
  try {
    const response = await authHttp().post(routes.urlAssocTpEmpresas, item)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveAssocTpEmissor(item) {
  try {
    const response = await authHttp().post(routes.urlAssocTpEmissores, item)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveAssocTpPermission(tp_id, item) {
  try {
    const response = await authHttp().post(routes.urlAssocTpPermissions, { tp_id, ...item })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveTpLogoPath(tp_id, filepath) {
  try {
    const response = await authHttp().post(routes.urlTpLogoApi(tp_id), { filepath })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function gerarTokenRoboXml(tp_id) {
  try {
    const response = await authHttp().get(routes.urlGenerateTokenRoboXml(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
